class ChromeAutoCompleteHelper {
	static hideAutocomplete(input) {
		if (!input) {
			return;
		}
		input.setAttribute('data-original-name', input.name);
		input.setAttribute(
			'name',
			Math.random()
				.toString(36)
				.substring(7)
		);
	}
	static showAutocomplete(input) {
		if (!input) {
			return;
		}
		const originalName = input.getAttribute('data-original-name');
		if (originalName) {
			input.setAttribute('name', originalName);
		}
	}
}

export default ChromeAutoCompleteHelper;
